import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import React, { FC } from 'react'

import { InputStyled } from '@/components/Input/Input/Input.styles'

type Props = {
  currentFilters: HomeFilters
}
export const NotesSelection: FC<Props> = ({ currentFilters }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()

  const handleChange = (e) => {
    const val = e.target.value
    if (val) {
      WorkspaceDispatch(
        WorkspaceAction.updateFilters({
          notes: val,
        }),
      )
    }
  }

  return (
    <div className={`flex h-full w-full flex-col border-b py-2 border-secondary`}>
      <p className="font-weight[500] font-bold text-tertiary">Notes</p>
      <textarea css={InputStyled} onChange={handleChange} rows={4} value={currentFilters.notes || ''} />
    </div>
  )
}
